import React, {useContext, useState} from "react";
import ModalNeedAuth from "../modals/need-auth";
import {AppContext} from "../../contexts/app-context";
import i18n from "../../i18n";


export function GuestHeaderButton({delivery, setStopListUpdate}) {
  const appContext = useContext(AppContext);
  const [showModalCreateOrder, setShowModalCreateOrder] = useState(false);
  const user = appContext.user;

  const text = delivery.Logist.Phone ?
    i18n.t('components.tools.guestHeaderButton.text.1', {'phone': delivery.Logist.Phone}) :
    i18n.t('components.tools.guestHeaderButton.text.2');

  if (user.isGuest()) {
    return (
      <div>
        <a
          href="#"
          className="action-button"
          onClick={(e) => {
            e.preventDefault();
            setStopListUpdate(true);
            setShowModalCreateOrder(true);
          }}
        >
          <span className="speedometer">{i18n.t('components.tools.guestHeaderButton.buttons.action')}</span>
        </a>
        <ModalNeedAuth
          isShow={showModalCreateOrder}
          setIsShow={setShowModalCreateOrder}
          setStopListUpdate={setStopListUpdate}
          text={text}
          title={i18n.t('components.tools.guestHeaderButton.modalTitle')}
        />
      </div>
    );
  }

  return null;
}
